import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_PERSONNEL_LOAD,
    ACTION_PERSONNEL_LOAD_BY_ID,
    ACTION_PERSONNEL_LOAD_FAILURE,
    ACTION_PERSONNEL_LOAD_SUCCESS,

    ACTION_PERSONNEL_SAVE,
    ACTION_PERSONNEL_SAVE_SUCCESS,
    ACTION_PERSONNEL_SAVE_FAILURE,

    ACTION_PERSONNEL_VALIDATE,
    ACTION_PERSONNEL_VALIDATE_SUCCESS,
    ACTION_PERSONNEL_VALIDATE_FAILURE,

    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY,
    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_SUCCESS,
    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_FAILURE,

    ACTION_PERSONNEL_CREATE,
    ACTION_PERSONNEL_CREATE_SUCCESS,
    ACTION_PERSONNEL_CREATE_FAILURE,

    ACTION_PERSONNEL_RESENDEMAIL,
    ACTION_PERSONNEL_RESENDEMAIL_SUCCESS,
    ACTION_PERSONNEL_RESENDEMAIL_FAILURE,

    ACTION_PERSONNEL_CLEAR,
    ACTION_PERSONNEL_FILTER,

    ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID,
    ACTION_PERSONNEL_PERMISSIONS_LOAD_FAILURE,
    ACTION_PERSONNEL_PERMISSIONS_LOAD_SUCCESS,

    // ACTION_PERSONNEL_BY_ROLE_LOAD,
    ACTION_PERSONNEL_BY_ROLE_LOAD_FAILURE,
    ACTION_PERSONNEL_BY_ROLE_LOAD_SUCCESS,
    ACTION_PERSONNEL_FILTER_BY_ROLE,

    PersonnelAction,
    ACTION_PERSONNEL_CATEGORY_SUCCESS,
    ACTION_PERSONNEL_TMD_ROLE_SUCCESS,
    ACTION_PERSONNEL_TMD_TRIAL_SUCCESS,
    ACTION_PERSONNEL_TRIAL_GROUP_SUCCESS,
    ACTION_PERSONNEL_TMD_ROLE_UPDATE,
    ACTION_PERSONNEL_TMD_TRIAL_UPDATE,
    ACTION_PERSONNEL_CATEGORY_UPDATE,
    ACTION_PERSONNEL_TRIAL_GROUP_UPDATE,
    SearchType,
    ACTION_PERSONNEL_ADVANCED_SEARCH_SUCCESS, 
    ACTION_PERSONNEL_ADVANCED_SEARCH, 
    ACTION_PERSONNEL_ADVANCED_SEARCH_FAILURE
} from '../actions/personnel';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";
import {Personnel} from "../dtos/Tmd.dtos";

export interface IPersonnelState {
    formData: Dtos.Personnel | Dtos.Personnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    validateState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    resendingState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.Personnel[];
    formLength: number;
    loadPermissionsState: IRequestState;
    groupedPersonnelPermissions: Dtos.PersonnelPermissionGroup[];
    rolePersonnelGroupings: Dtos.RolePersonnelGrouping[];
    rolePersonnelGroupingsFiltered: Dtos.RolePersonnelGrouping[];
    formFilterByRole: IFormFilter;

    advancedSearchTMDRole: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrial: Dtos.PersonnelTmdTrial[];
    advancedSearchCategory: Dtos.PersonnelCategory[];
    advancedSearchTrialGroup: Dtos.PersonnelTrialGroup[];

    advancedSearchTMDRoleAND: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrialAND: Dtos.PersonnelTmdTrial[];
    advancedSearchCategoryAND: Dtos.PersonnelCategory[];
    advancedSearchTrialGroupAND: Dtos.PersonnelTrialGroup[];

    advancedSearchTMDRoleNOT: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrialNOT: Dtos.PersonnelTmdTrial[];
    advancedSearchCategoryNOT: Dtos.PersonnelCategory[];
    advancedSearchTrialGroupNOT: Dtos.PersonnelTrialGroup[];
    
    loadingAdvancedSearch: boolean;
    displayAdvancedSearch: boolean;
}

const initialState: IPersonnelState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    resendingState: {
        status: RequestState.None
    } as IRequestState,
    loadPermissionsState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0,
    groupedPersonnelPermissions: [],
    rolePersonnelGroupings: [],
    rolePersonnelGroupingsFiltered: [],
    formFilterByRole: {
        search: "",
        showInActive: false
    },
    advancedSearchTMDRole: [],
    advancedSearchTMDTrial: [],
    advancedSearchCategory: [],
    advancedSearchTrialGroup: [],
    
    advancedSearchTMDRoleAND: [],
    advancedSearchTMDTrialAND: [],
    advancedSearchCategoryAND: [],
    advancedSearchTrialGroupAND: [],
    
    advancedSearchTMDRoleNOT: [],
    advancedSearchTMDTrialNOT: [],
    advancedSearchCategoryNOT: [],
    advancedSearchTrialGroupNOT: [],

    loadingAdvancedSearch: false,
    displayAdvancedSearch: false
};


function loading(state: IPersonnelState, _isLoading: boolean): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });
    return newState;
}

function loadSuccess(state: IPersonnelState,
    formData: Dtos.Personnel | Dtos.Personnel[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        },
        displayAdvancedSearch: {
            $set: false
        },
    });

    return filter(newState, state.formFilter);
}

function loadFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filter(state: IPersonnelState, formFilter: IFormFilter): IPersonnelState {

    const items: Dtos.Personnel[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;
    
    const formLength = items ? items.length : 0;

    const formFilteredData = items ? items.filter(p => (p.active == true || formFilter.showInActive) &&
        (
            formFilter.search == ""
            || p.display.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1
            || (p.email != undefined && p.email != null && p.email != '' && p.email.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)
        )
    ) : undefined;

    const newState: IPersonnelState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function clear(state: IPersonnelState, propertiesToClear?: string[]): IPersonnelState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IPersonnelState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IPersonnelState, _isSaving: boolean): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IPersonnelState,
    formData: Dtos.Personnel | Dtos.Personnel[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: IPersonnelState, _isValidating: boolean): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IPersonnelState,
    formData: Dtos.Personnel,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IPersonnelState, _isCreating: boolean): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IPersonnelState,
    formData: Dtos.Personnel,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function resending(state: IPersonnelState, isRunning: boolean): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        resendingState: {
            $set: {
                status: isRunning ? RequestState.Pending : RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function resendingFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        resendingState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        }
    });

    return newState;
}

function loadingPermissions(state: IPersonnelState, _isLoading: boolean): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        loadPermissionsState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });
    return newState;
}

function loadPermissionsSuccess(state: IPersonnelState,
    formData: Dtos.PersonnelPermissionGroup[],
    responseStatus: Dtos.ResponseStatus
): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        groupedPersonnelPermissions: {
            $set: formData
        },
        loadPermissionsState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return filter(newState, state.formFilter);
}

function loadPermissionsFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        loadPermissionsState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function loadByRoleSuccess(state: IPersonnelState,
    formData: Dtos.RolePersonnelGrouping[],
    responseStatus: Dtos.ResponseStatus
): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        rolePersonnelGroupings: {
            $set: formData
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filterByRole(newState, state.formFilter);
}

function loadByRoleFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function filterByRole(state: IPersonnelState, formFilter: IFormFilter): IPersonnelState {

    const search = formFilter.search?.trim()?.toLowerCase();

    const filteredItems: Dtos.RolePersonnelGrouping[] = state.rolePersonnelGroupings
        .map(group => {

            const filteredPersonnels = group?.rolePersonnels?.filter(person =>
                `${person.firstName} ${person.lastName}`?.toLowerCase().includes(search)
            );

            if (filteredPersonnels.length === 0) {
                return null;
            }

            return {
                ...group,
                rolePersonnels: filteredPersonnels
            };
        })
        .filter((group): group is Dtos.RolePersonnelGrouping => group !== null);

    const newState: IPersonnelState = update(state, {
        formFilterByRole: { $set: formFilter },
        rolePersonnelGroupingsFiltered: { $set: filteredItems }
    });

    return newState;
}

function tmdRole(state: IPersonnelState, tmdRoles: Dtos.PersonnelTmdRole[]): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        advancedSearchTMDRole: {
            $set: tmdRoles
        },
        advancedSearchTMDRoleAND: {
            $set: tmdRoles
        },
        advancedSearchTMDRoleNOT: {
            $set: tmdRoles
        }
    })
    return newState
}

function tmdRoleUpdate(state: IPersonnelState, tmdRoles: Dtos.PersonnelTmdRole[], searchType: SearchType): IPersonnelState {
    switch (searchType) {
        case SearchType.Search: {
            return update(state, {
                advancedSearchTMDRole: {
                    $set: tmdRoles
                }
            })
        }
        case SearchType.SearchAND: {
            return update(state, {
                advancedSearchTMDRoleAND: {
                    $set: tmdRoles
                }
            })
        }
        case SearchType.SearchNOT: {
            return update(state, {
                advancedSearchTMDRoleNOT: {
                    $set: tmdRoles
                }
            })
        }
    }
}

function tmdTrialUpdate(state: IPersonnelState, tmdTrial: Dtos.PersonnelTmdTrial[], searchType: SearchType): IPersonnelState {
    switch (searchType) {
        case SearchType.Search: {
            return update(state, {
                advancedSearchTMDTrial: {
                    $set: tmdTrial
                }
            })
        }
        case SearchType.SearchAND: {
            return update(state, {
                advancedSearchTMDTrialAND: {
                    $set: tmdTrial
                }
            })
        }
        case SearchType.SearchNOT: {
            return update(state, {
                advancedSearchTMDTrialNOT: {
                    $set: tmdTrial
                }
            })
        }
    }
}

function tmdCategoryUpdate(state: IPersonnelState, category: Dtos.PersonnelCategory[], searchType: SearchType): IPersonnelState {
    switch (searchType) {
        case SearchType.Search: {
            return update(state, {
                advancedSearchCategory: {
                    $set: category
                }
            })
        }
        case SearchType.SearchAND: {
            return update(state, {
                advancedSearchCategoryAND: {
                    $set: category
                }
            })
        }
        case SearchType.SearchNOT: {
            return update(state, {
                advancedSearchCategoryNOT: {
                    $set: category
                }
            })
        }
    }
}

function trialGroupUpdate(state: IPersonnelState, trialGroup: Dtos.PersonnelTrialGroup[], searchType: SearchType): IPersonnelState {
    switch (searchType) {
        case SearchType.Search: {
            return update(state, {
                advancedSearchTrialGroup: {
                    $set: trialGroup
                }
            })
        }
        case SearchType.SearchAND: {
            return update(state, {
                advancedSearchTrialGroupAND: {
                    $set: trialGroup
                }
            })
        }
        case SearchType.SearchNOT: {
            return update(state, {
                advancedSearchTrialGroupNOT: {
                    $set: trialGroup
                }
            })
        }
    }
}

function tmdTrial(state: IPersonnelState, tmdTrials: Dtos.PersonnelTmdTrial[]): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        advancedSearchTMDTrial: {
            $set: tmdTrials
        },
        advancedSearchTMDTrialAND: {
            $set: tmdTrials
        },
        advancedSearchTMDTrialNOT: {
            $set: tmdTrials
        }
    })
    return newState
}

function category(state: IPersonnelState, category: Dtos.PersonnelCategory[]): IPersonnelState {
    console.dir(category);
    const newState: IPersonnelState = update(state, {
        advancedSearchCategory: {
            $set: category
        },
        advancedSearchCategoryAND: {
            $set: category
        },
        advancedSearchCategoryNOT: {
            $set: category
        }
    })
    return newState
}

function trialGroup(state: IPersonnelState, trialGroups: Dtos.PersonnelTrialGroup[]): IPersonnelState {
    const newState: IPersonnelState = update(state, {
        advancedSearchTrialGroup: {
            $set: trialGroups
        },
        advancedSearchTrialGroupAND: {
            $set: trialGroups
        },
        advancedSearchTrialGroupNOT: {
            $set: trialGroups
        }
    })
    return newState
}

function advancedSearch(state: IPersonnelState) {
    const newState: IPersonnelState = update(state, {
        loadingAdvancedSearch: {
            $set: true
        }
    });
    return newState;    
}

function advancedSearchSuccess(state: IPersonnelState, personnel: Personnel[]) {
    const newState: IPersonnelState = update(state, {
        formData: {
            $set: personnel
        },
        displayAdvancedSearch: {
            $set: true
        },
        loadingAdvancedSearch: {
            $set: false
        }
    });
    return filter(newState, state.formFilter);
}

function advancedSearchFailure(state: IPersonnelState, responseStatus: Dtos.ResponseStatus) {
    const newState: IPersonnelState = update(state, {
        formData: {
            $set: []
        },
        loadingAdvancedSearch: {
            $set: false
        }
    });
    return loadFailure(newState, responseStatus);
}

const PersonnelReducer: Reducer<IPersonnelState> = (state: IPersonnelState = initialState, action: PersonnelAction) => {
    switch (action.type) {
        case ACTION_PERSONNEL_LOAD:
        case ACTION_PERSONNEL_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_PERSONNEL_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_PERSONNEL_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_PERSONNEL_SAVE:
        case ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY:
            return saving(state, true);
        case ACTION_PERSONNEL_SAVE_SUCCESS:
        case ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_PERSONNEL_SAVE_FAILURE:
        case ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_VALIDATE:
            return validating(state, true);
        case ACTION_PERSONNEL_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_PERSONNEL_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_CREATE:
            return creating(state, true);
        case ACTION_PERSONNEL_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_PERSONNEL_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_FILTER:
            return filter(state, action.formFilter);
        case ACTION_PERSONNEL_RESENDEMAIL:
            return resending(state, true);
        case ACTION_PERSONNEL_RESENDEMAIL_SUCCESS:
            return resending(state, false);
        case ACTION_PERSONNEL_RESENDEMAIL_FAILURE:
            return resendingFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID:
            return loadingPermissions(state, true);
        case ACTION_PERSONNEL_PERMISSIONS_LOAD_SUCCESS:
            return loadPermissionsSuccess(state, action.data, action.responseStatus);
        case ACTION_PERSONNEL_PERMISSIONS_LOAD_FAILURE:
            return loadPermissionsFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_BY_ROLE_LOAD_SUCCESS:
            return loadByRoleSuccess(state, action.formData, action.responseStatus);
        case ACTION_PERSONNEL_BY_ROLE_LOAD_FAILURE:
            return loadByRoleFailure(state, action.responseStatus);
        case ACTION_PERSONNEL_FILTER_BY_ROLE:
            return filterByRole(state, action.formFilter);
        case ACTION_PERSONNEL_TMD_ROLE_SUCCESS:
            return tmdRole(state, action.tmdRole)
        case ACTION_PERSONNEL_TMD_TRIAL_SUCCESS:
            return tmdTrial(state, action.tmdTrial)
        case ACTION_PERSONNEL_CATEGORY_SUCCESS:
            return category(state, action.category)
        case ACTION_PERSONNEL_TRIAL_GROUP_SUCCESS:
            return trialGroup(state, action.trialGroup)
        case ACTION_PERSONNEL_TMD_ROLE_UPDATE:
            return tmdRoleUpdate(state, action.tmdRole, action.searchType)
        case ACTION_PERSONNEL_TMD_TRIAL_UPDATE:
            return tmdTrialUpdate(state, action.tmdTrial, action.searchType)
        case ACTION_PERSONNEL_CATEGORY_UPDATE:
            return tmdCategoryUpdate(state, action.category, action.searchType)
        case ACTION_PERSONNEL_TRIAL_GROUP_UPDATE:
            return trialGroupUpdate(state, action.trialGroup, action.searchType)
        case ACTION_PERSONNEL_ADVANCED_SEARCH:
            return advancedSearch(state)
        case ACTION_PERSONNEL_ADVANCED_SEARCH_SUCCESS:
            return advancedSearchSuccess(state, action.personnel)
        case ACTION_PERSONNEL_ADVANCED_SEARCH_FAILURE:
            return advancedSearchFailure(state, action.responseStatus)
    }

    return state;
}

export default PersonnelReducer;